import SchoolTeacher from '../images/school_teacher.svg';
import EliteTutor from '../images/elite_tutor.svg';
import InHouseTutor from '../images/in_house_tutor.svg';
import FavouritedByReach10 from '../images/favorited_by_reach_10.svg';
import FavouritedByReach50 from '../images/favorited_by_reach_50.svg';
import FavouritedByReach100 from '../images/favorited_by_reach_100.svg';
import AnsweredQuestionsReached50 from '../images/answered_question_reach_50.svg';
import AnsweredQuestionsReached100 from '../images/answered_question_reach_100.svg';
import AnsweredQuestionsReached500 from '../images/answered_question_reach_500.svg';
import AnsweredQuestionsReached1000 from '../images/answered_question_reach_1000.svg';

export const AVERAGE_RATE = 'AVERAGE_RATE';
export const ANSWER_COUNT = 'ANSWER_COUNT';
export const SCHOOL_TEACHER = 'school_teacher';
export const ELITE_TUTOR = 'elite_tutor';
export const IN_HOUSE_TUTOR = 'in_house_tutor';
export const FAVOURITED_BY_REACH_100 = 'favorited_by_reach_100';
export const FAVOURITED_BY_REACH_50 = 'favorited_by_reach_50';
export const FAVOURITED_BY_REACH_10 = 'favorited_by_reach_10';
export const ANSWERED_QUESTIONS_REACH_1000 = 'answered_question_reach_1000';
export const ANSWERED_QUESTIONS_REACH_500 = 'answered_question_reach_500';
export const ANSWERED_QUESTIONS_REACH_100 = 'answered_question_reach_100';
export const ANSWERED_QUESTIONS_REACH_50 = 'answered_question_reach_50';

const ANSWER_COUNT_CLASS = 'answerCount';
const AVERAGE_RATE_CLASS = 'averageRate';
const QUESTION_ANSWERED_CLASS = 'questionsAnswered';
const FAVOURITED_BY_CLASS = 'favouritedBy';
const SCHOOL_TEACHER_CLASS = 'schoolTeacher';

export const BADGE_COLORS = {
  [ANSWER_COUNT]: ANSWER_COUNT_CLASS,
  [AVERAGE_RATE]: AVERAGE_RATE_CLASS,
  [ANSWERED_QUESTIONS_REACH_1000]: QUESTION_ANSWERED_CLASS,
  [ANSWERED_QUESTIONS_REACH_500]: QUESTION_ANSWERED_CLASS,
  [ANSWERED_QUESTIONS_REACH_100]: QUESTION_ANSWERED_CLASS,
  [ANSWERED_QUESTIONS_REACH_50]: QUESTION_ANSWERED_CLASS,
  [FAVOURITED_BY_REACH_100]: FAVOURITED_BY_CLASS,
  [FAVOURITED_BY_REACH_50]: FAVOURITED_BY_CLASS,
  [FAVOURITED_BY_REACH_10]: FAVOURITED_BY_CLASS,
  [SCHOOL_TEACHER]: SCHOOL_TEACHER_CLASS,
  [IN_HOUSE_TUTOR]: ANSWER_COUNT_CLASS,
  [ELITE_TUTOR]: AVERAGE_RATE_CLASS,
};

export const BADGE_IMAGES = {
  [ANSWERED_QUESTIONS_REACH_1000]: AnsweredQuestionsReached1000,
  [ANSWERED_QUESTIONS_REACH_500]: AnsweredQuestionsReached500,
  [ANSWERED_QUESTIONS_REACH_100]: AnsweredQuestionsReached100,
  [ANSWERED_QUESTIONS_REACH_50]: AnsweredQuestionsReached50,
  [FAVOURITED_BY_REACH_100]: FavouritedByReach100,
  [FAVOURITED_BY_REACH_50]: FavouritedByReach50,
  [FAVOURITED_BY_REACH_10]: FavouritedByReach10,
  [SCHOOL_TEACHER]: SchoolTeacher,
  [IN_HOUSE_TUTOR]: InHouseTutor,
  [ELITE_TUTOR]: EliteTutor,
};



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountAchievements/constants/tutorBadges.js